import PropTypes from 'prop-types';
import SceneToggleButton from './SceneToggleButton';

function TextureToggle({
    toggle,
}) {
    return (
        <SceneToggleButton
            ariaLabel={toggle.ariaLabel}
            ariaPressed={toggle.ariaPressed}
            className={`scene-toggle ${toggle.active ? 'active' : ''}`}
            disabled={toggle.disabled}
            onClick={toggle.onClick}
            title={toggle.title}
        >
            <>
                <span className="scene-toggle-icon-shell">
                    <i className="material-icons icon" role="presentation">texture</i>
                </span>
                <span>Texture</span>
            </>
        </SceneToggleButton>
    );
}

TextureToggle.propTypes = {
    toggle: PropTypes.shape({
        active: PropTypes.bool.isRequired,
        ariaLabel: PropTypes.string.isRequired,
        ariaPressed: PropTypes.bool.isRequired,
        disabled: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

export default TextureToggle;
